/* eslint-disable @typescript-eslint/no-unused-vars */
import { Redirect, Route } from "react-router-dom";
import {
  IonApp,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  IonToolbar,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Donations from "./pages/Donations";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";

import "./theme";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { useRef } from "react";
import { AgeCheckModal } from "./components/AgeCheckModal";
import { close } from "ionicons/icons";

const firebaseConfig = {
  apiKey: "AIzaSyD-BoM9zzSMbAy8a-0SxBcZ0H-rXbXjvgs",
  authDomain: "nickiwoods.firebaseapp.com",
  projectId: "nickiwoods",
  storageBucket: "nickiwoods.appspot.com",
  messagingSenderId: "639160624932",
  appId: "1:639160624932:web:79fa342c95b51d950af5b1",
  measurementId: "G-9G4LFFKTYY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

setupIonicReact({
  mode: "ios",
});

const App: React.FC = () => {
  return (
    <IonApp>
      <AgeCheckModal />
      <IonReactRouter>
        <IonSplitPane contentId="main" when={false}>
          <SideMenu
            buttons={[
              {
                label: "Home",
                href: "/home",
              },
              {
                label: "Gallery",
                href: "/gallery",
              },
              {
                label: "Donations",
                href: "/donations",
              },
              {
                label: "Contact",
                href: "/contact",
              },
              {
                label: "Wishlist",
                href: "/wishlist",
              },
            ]}
          />
          <IonRouterOutlet id="main">
            <Route exact path="/home">
              <Home />
            </Route>
            <Route exact path="/gallery">
              <Gallery />
            </Route>
            <Route exact path="/donations">
              <Donations />
            </Route>
            <Route exact path="/contact">
              <Contact />
            </Route>
            <Route exact path="/wishlist">
              <Wishlist />
            </Route>
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;

// create a modal with a backdrop using Tailwindcss

const SideMenu: React.FC<{ buttons: any }> = ({ buttons }) => {
  return (
    <IonMenu contentId="main">
      <IonHeader translucent>
        <IonToolbar>
          <IonTitle>Menu</IonTitle>
          <IonButtons slot="end">
            <IonMenuToggle>
              <IonButton>
                <IonIcon icon={close} />
              </IonButton>
            </IonMenuToggle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" translucent>
          <IonToolbar>
            <IonTitle></IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="">
          <NavButtons buttons={buttons} />
          {/* {buttons.map(
            (button: any): JSX.Element => (
              <IonButton className="" fill="clear" key={button.label} href={button.href}>
                <IonLabel>{button.label}</IonLabel>
              </IonButton>
            )
          )} */}
        </div>
      </IonContent>
    </IonMenu>
  );
};

// DIV with a vertical direction of flex with Tailwindcss
const NavButtons: React.FC<{ buttons: any }> = ({ buttons }) => {
  return (
    <div className="flex flex-col">
      {buttons.map(
        (button: any): JSX.Element => (
          <IonButton
            className=""
            fill="clear"
            key={button.label}
            href={button.href}
          >
            <IonLabel>{button.label}</IonLabel>
          </IonButton>
        )
      )}
    </div>
  );
};
